<template>
  <div class="page-header-index-wide">
    <a-row :gutter="24">
      <div v-for="model in models" :key="model.id">
        <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
          <a-card :loading="loading" :title="model.uid_name" :hoverable="true" @click="handelTip">
            <div slot="extra" v-show="!saving" @click="updateModel(model.id)">
              <a-icon type="check" v-if="model.checked" />
              <a-icon type="close-circle" v-else />
            </div>
            <p>模型id： {{ model.model_id }}</p><p>模型描述： {{ model.model_description }}</p>
          </a-card>
        </a-col>
      </div>
    </a-row>
  </div>
</template>

<script>

import { getAllModelList, getItemModelList, updateModelItem } from '@/api/model'
import { mapState } from 'vuex'
export default {
  name: 'LabelStatus',
  data () {
    return {
      loading: false,
      models: [],
      saving: false
    }
  },
  created () {
    const _this = this
    getAllModelList().then(res => {
      _this.models = res.data.map(item => {
        item.checked = false
        return item
      })
      _this.loadModel()
    })
  },
  methods: {

    loadModel () {
      const _this = this
      for (var i = 0; i < _this.models.length; i++) {
        _this.$set(_this.models[i], 'checked', false)
      }
      this.$store.dispatch('FetchDiagnoseModels').then(diagnoseModels =>
        diagnoseModels.map(item => {
          for (var i = 0; i < _this.models.length; i++) {
            if (_this.models[i].model_id == item.model_id)_this.$set(_this.models[i], 'checked', true)
          }
        })
      )
    },
    generateModelsString () {
      const models = this.models
      var checkedModels = []
      for (var i = 0; i < models.length; i++) {
        if (models[i].checked)checkedModels.push(models[i].id)
      }
      return checkedModels.join(',')
    },
    updateModel (id) {
      this.saving = true
      const models = this.models
      var index = indexOf(id)
      if (index == -1) return
      this.$set(this.models[index], 'checked', toggle(index))
      const _this = this
      var x = _this.$store.getters.projectId
      updateModelItem({
        item_id: parseInt(_this.$store.getters.projectId),
        model_id: this.generateModelsString()
      }).then(res => {
        if (res.code != 200) throw ''
        this.$store.dispatch('FetchDiagnoseModels')
      }).catch(() => {
        _this.$message.error('模型配置失败')
      }).finally(() => {
        this.saving = false
      })
      function indexOf (id) {
        for (var i = 0; i < models.length; i++) {
          if (models[i].id == id) return i
        }
        return -1
      }
      function toggle (index) {
        return !models[index].checked
      }
    },
    handelTip () {
      if (this.saving == false) this.$message.info('点击右上角圆圈配置该模型')
    }
  }
}
</script>

<style lang="less" scoped>
  .extra-wrapper {
    line-height: 55px;
    padding-right: 24px;

    .extra-item {
      display: inline-block;
      margin-right: 24px;

      a {
        margin-left: 24px;
      }
    }
  }
</style>
